import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Logo from '../common/Logo';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Logo and Description */}
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4 flex items-center gap-3">
              <Logo size="md" showText={false} />
              <span className="text-2xl font-bold text-white">{t('site.name')}</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-md">
              {t('site.description')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.quickLinks')}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-primary-400 transition text-sm">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/candidates" className="text-gray-400 hover:text-primary-400 transition text-sm">
                  {t('nav.candidates')}
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-gray-400 hover:text-primary-400 transition text-sm">
                  {t('nav.login')}
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-gray-400 hover:text-primary-400 transition text-sm">
                  {t('nav.register')}
                </Link>
              </li>
              <li>
                <Link to="/security" className="text-gray-400 hover:text-primary-400 transition text-sm">
                  {t('footer.security')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{t('footer.contact')}</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>{t('footer.rspNepal')}</li>
              <li>{t('footer.kathmandu')}</li>
              <li>{t('footer.phone')}</li>
              <li className="pt-2">
                <a
                  href={`mailto:${t('footer.email')}`}
                  className="hover:text-primary-400 transition"
                >
                  {t('footer.email')}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              {t('footer.copyright', { year: currentYear })}
            </p>
            <div className="flex items-center gap-2 text-sm">
              <span className="text-gray-400">{t('common.poweredBy')}</span>
              <a
                href="https://niwarika.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-400 hover:text-primary-300 font-semibold transition"
              >
                Niwarika Tech Pvt. Ltd.
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
